export default "/images/file-pdf.svg?9a2770f2c8683c0e56e70563eb5d3662";